<style scoped>
  .v-card {
    border: none;
  }
  .v-card.selected {
    //border: 1px solid #1B5E20;
  }
  .v-dialog__content {
    align-items: start;
  }
  .templateScenario-container {
    display: flex;
    //gap: 30px;
    justify-content: center;
    //margin-top: 20px;
    flex-direction: column;
    align-items: flex-start;
    margin-left: -20px;
    @media (min-width: 1000px) {
      //flex-direction: row;
      width: 400px;
    }
    .v-card {
      padding: 15px;
      text-align: left;
      //max-width: 220px;
      @media (min-width: 1000px) {
        //max-width: 450px;
      }
    }
  }

  .header {
    font-weight: bold;
    line-height: 1.2;
  }
  .fcst-periods-container {
    display: flex;
    gap: 10px;
    @media (min-width: 1000px) {
      gap: 40px;
    }
  }

  .field-container {
    display: flex;
    margin-top: 10px;
    align-items: center;
    &.stacked-on-small {
      flex-direction: column;
      align-items: inherit;
    }
    > :first-child {
      flex: 0 0 50%;
    }
    > :last-child {
      margin-top: 20px;
    }
    @media (min-width: 1000px) {
      flex-direction: row;
      gap: 60px;
      align-items: start;
      &.stacked-on-small {
        flex-direction: row;
        //align-items: center;
      }
      > :first-child {
        //margin-top: 10px;
        flex: 0 0 200px;
      }
      > :last-child {
        margin-top: 0;
      }
    }
  }
  .generated-item:not(:last-child) {
    margin-bottom: 20px;
  }
</style>

<template>
  <div style="margin: 0 auto; width: 100%;">
    <!--      @click:outside="onDialogCancel"-->
    <div style="background-color: #fff; width: 700px; max-width: 100%;">
      <div v-if="$store.state.activeTemplate.isGenerating === 'progress'" style="padding: 10px;">
        <div style="text-align: center; margin-bottom: 5px; display: flex; justify-content: center; gap: 20px; align-items: center;">
          {{ translate('ui_dialog_onboarding__generating') }}
          <div style="display: flex; align-items: start; flex-direction: column; font-size: 14px;">
            <div v-for="(itemToGenerate) in itemsToGenerate" :key="itemToGenerate.id" class="generated-item">
              <div v-if="itemToGenerate.isInitialized !== true">
                <v-icon v-if="itemToGenerate.icon !== 'none'" style="font-size: 16px; color: #000; margin-left: 5px;">
                  {{ itemToGenerate.icon ? itemToGenerate.icon : 'mdi-table' }}
                </v-icon>
                {{ itemToGenerate.label }}
              </div>
            </div>
          </div>
        </div>
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="2"
          style="margin-bottom: 5px;"
        ></v-progress-linear>
      </div>

      <div v-if="$store.state.activeTemplate.isGenerating === 'init'" style="padding: 30px;">
        <div style="text-align: center;">
          <strong style="font-size: 20px;">{{ translate('ui_dialog_onboarding__header') }}</strong>
          <div style="font-size: 14px; color: #555;">{{ translate('ui_dialog_onboarding__subheader') }}</div>
        </div>
        <div class="field-container stacked-on-small" style="margin-top: 30px;">
          <div>
            <div class="header">{{ translate('ui_dialog_onboarding__business_category') }}</div>
            <div style="font-size: 14px; line-height: 1.2;">{{ translate('ui_dialog_onboarding__business_category_helper_text') }}</div>
          </div>
          <v-text-field
            ref="businessCategory"
            v-model="$store.state.activeTemplate.data.openAIPrompt"
            required
            counter="50"
            maxlength="50"
            style="margin-top: 0; padding-top: 0;"
          ></v-text-field>
        </div>

        <div class="field-container stacked-on-small" style="margin-top: 30px;">
          <div class="header">{{ translate('ui_dialog_onboarding__currency_and_forecast_length') }}</div>
          <div style="display: flex; gap: 20px;">
            <v-text-field
              id="section_currency__input_currency_name_input"
              :label="translate('ui_dialog_onboarding__currency')"
              :value="defaultCurrency"
              required
              ref="defaultCurrency"
              style="margin-top: 0; padding-top: 0;"
            ></v-text-field>
            <v-select
            :label="translate('ui_dialog_onboarding__forecast_period')"
            v-model="$store.state.activeTemplate.data.options.timing.periodicity"
            :items="periods"
            id="assumptions_period_type_input"
            background-color="white"
            style="margin-top: 0; padding-top: 0;"
          ></v-select>
            <v-text-field
              :label="translate('ui_dialog_onboarding__forecast_length')"
              v-model="$store.state.activeTemplate.layout.cFcstColCount"
              id="assumptions_fcst_periods_input"
              required
              style="margin-top: 0; padding-top: 0;"
            ></v-text-field>
          </div>
        </div>

        <div class="field-container" style="display: none;">
          <div class="header">{{ translate('ui_dialog_onboarding__fcst_length') }}</div>
          <div class="fcst-periods-container">
            <v-text-field
              v-model="$store.state.activeTemplate.layout.cFcstColCount"
              id="assumptions_fcst_periods_input"
              required
              style="margin-top: 0; padding-top: 0;"
            ></v-text-field>
            <v-select
              id="assumptions_period_type_input"
              :items="periods"
              v-model="$store.state.activeTemplate.data.options.timing.periodicity"
              background-color="white"
              style="margin-top: 0; padding-top: 0;"
            ></v-select>
          </div>
        </div>

        <div class="field-container stacked-on-small" style="margin-top: 30px;">
          <div class="header">{{ translate('ui_dialog_onboarding__model_purpose') }}</div>
          <div class="templateScenario-container">
            <v-list
              flat
              subheader
              three-line
            >
              <v-list-item-group multiple>
                <v-list-item v-for="(templateScenario, index) in templateScenarios" :key="index" style="min-height: auto; padding: 0;">
                  <template>
                    <v-list-item-action style="margin: 0px 15px;">
                      <v-checkbox
                        v-if="templateScenario.default"
                        v-model="templateScenario.selected"
                        style="margin: 0; padding: 0;"
                        hide-details
                        disabled
                      ></v-checkbox>
                      <v-checkbox
                        v-if="!templateScenario.default"
                        @click="selectTemplateScenario(templateScenario)"
                        :value="templateScenario.selected === true"
                        color="green darken-2"
                        style="margin: 0; padding: 0;"
                        hide-details
                      ></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content style="align-self: start; padding-top: 7px;" @click="selectTemplateScenario(templateScenario)">
                      <v-list-item-title style="color: #000;">{{ templateScenario.content }}</v-list-item-title>
                      <v-list-item-subtitle style="margin-top: 0px; line-clamp: none; font-size: 13px;">{{ templateScenario.description }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>

            <v-card
              style="display: none;"
              v-for="(templateScenario, index) in templateScenarios"
              :key="index"
              outlined
              :class="templateScenario.selected ? 'selected' : ''"
            >
              <div style="display: flex; gap: 5px;">
                <v-checkbox
                  v-model="templateScenario.selected"
                  :color="templateScenario.default ? '#555555' : 'green darken-2'"
                  style="margin: 0; padding: 0;"
                  hide-details
                ></v-checkbox>
                <div style="text-align: left; padding-top: 8px;">
                  <div style="line-height: 1.2;">{{ templateScenario.content }}</div>
                </div>
              </div>

              <div style="font-size: 13px; line-height: 1.2; margin-left: 40px;">
                {{ templateScenario.description }}
              </div>
            </v-card>
          </div>
        </div>

        <div style="display: flex; justify-content: space-around; margin-top: 50px;">
          <v-btn
            @click="generateTemplate"
            color="primary"
            class="mr-4"
          >
            {{ translate('ui_dialog_onboarding__btn_generate') }}
          </v-btn>
        </div>
      </div>

      <div v-if="$store.state.activeTemplate.isGenerating === 'done'"
           style="display: flex; flex-direction: column; align-items: center; gap: 40px; padding: 30px;">
        <v-icon color="success" style="font-size: 80px;">mdi-check-circle-outline</v-icon>
        <div style="text-align: center; width: 300px;">
          <p style="font-size: 26px;">{{ translate('ui_dialog_onboarding_done__header') }}</p>
          {{ translate('ui_dialog_onboarding_done__content') }}
        </div>
        <v-btn color="primary" @click="onClose">{{ translate('ui_dialog_onboarding_done__btn_close') }}</v-btn>

        <div style="display: flex; gap: 40px; font-size: 14px; line-height: 1.2; margin: 0px 0 0; padding-bottom: 0; text-align: center; align-items: center;">
          <div>
            <span style="position: relative; display: inline-block;">
              <span style="line-height: 1.4;"
                    v-html=" translate('ui_can_download_model__content')"
              ></span>
            </span>
          </div>
          <div>
            <v-btn
              to="/feedback"
              target="_blank"
              style="text-decoration: none;"
            >
              <v-icon
                color="deep-purple accent-3"
              >mdi-message-text</v-icon>
            </v-btn>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>

import Mixin from '@/mixins/mixin';


export default {
  name: 'DialogOnboarding',
  components: {},
  mixins: [Mixin],
  data: () => ({
    open: true,
    isGeneratingModule: 'module_cover',
    enableTaxes: true,
    dialogAssumptions: [],
    templateScenarios: [],
    modulesToGenerate: [],
  }),
  methods: {
    generatedModuleName(module) {
      return this.translate(module.nameLong || module.id);
    },
    onDialogCancel() {
      if (this.$store.state.activeTemplate.isGenerating === 'init') {
        // auto-initialize some sections
        const sectionsToInitialize = ['section_general', 'section_timeline', 'section_environment', 'section_sales'];
        const { sections } = this.$store.state.activeTemplate.data;
        sections.forEach((section) => {
          if (sectionsToInitialize.includes(section.id)) {
            // eslint-disable-next-line
            // section.isInitialized = true;
          }
          // eslint-disable-next-line
          section.isGenerating = false;
        });
        this.$store.dispatch('updateState', {
          path: 'activeTemplate.data.sections',
          value: sections,
        });

        this.$store.commit('updateState', {
          path: 'activeTemplate.showOnboardingDialog',
          value: false,
        });
      }
    },
    initializingStatus(previewSectionId, status) {
      const { modules } = this.$store.state.activeTemplate.data;
      if (Array.isArray(previewSectionId)) {
        previewSectionId.forEach((previewSectionIdItem) => {
          const previewModule = modules.find((module) => module.id === previewSectionIdItem);
          previewModule.isInitialized = status;
        });
      } else {
        const previewModule = modules.find((module) => module.id === previewSectionId);
        previewModule.isInitialized = status;
      }
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.modules',
        value: modules,
      });
    },
    onClose() {
      this.$store.commit('updateState', {
        path: 'activeTemplate.showOnboardingDialog',
        value: false,
      });
      this.open = false;

      // display navigator
      const sectionId = this.$store.state.activeTemplate.data.modules[0].id;
      this.$store.commit('updateState', {
        path: 'activeTemplate.isNavigatorVisible',
        value: sectionId,
      });
    },
    async generateTemplate() {
      window.scroll({ top: 0, behavior: 'smooth' });
      this.$store.dispatch('updateState', {
        path: 'activeTemplate.isGenerating',
        value: 'progress',
      });

      // reset preview sections isInitialized - needed because if already generated once, the store values will be true
      const { modules } = this.$store.state.activeTemplate.data;
      this.initializingStatus(modules.map((m) => m.id), 'queued');

      // load the first few sheets
      // update template name
      this.$store.commit('updateState', {
        path: 'activeTemplate.name',
        value: this.$store.state.activeTemplate.data.openAIPrompt,
      });
      this.initializingStatus('module_cover', true);
      this.initializingStatus('module_assumptions', true);

      // decide which sections to display based on the onboarding scenario selected
      /* eslint-disable no-unreachable */
      const selectedTemplateScenariosModulesIds = this.templateScenarios.reduce((arr, t) => {
        if (t.selected) {
          arr.push(...t.modules);
        }
        return arr;
      }, []);

      selectedTemplateScenariosModulesIds.forEach((moduleId) => {
        const module = modules.find((m) => m.id === moduleId);
        // eslint-disable-next-line
        module.isEnabled = true;
      });
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.modules',
        value: modules,
      });

      this.$store.dispatch('previewModel');

      // sections to ask OpenAI about
      const sectionsToGenerate = modules.reduce((arr, module) => {
        if (module.templateSectionCfg && module.templateSectionCfg.isAIGenerationEnabled) {
          arr.push(module.templateSectionCfg.id);
        }
        return arr;
      }, []);

      // check if generating random data
      this.$store.commit('updateState', {
        path: 'isGeneratingSampleData',
        value: this.templateScenarios.find((s) => s.id === 'random-data'),
      });

      const promises = sectionsToGenerate.map((sectionToGenerate) => {
        const module = modules.find((m) => m.templateSectionCfg && m.templateSectionCfg.id === sectionToGenerate);
        this.modulesToGenerate.push(module);

        this.initializingStatus(module.id, 'progress');

        const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === sectionToGenerate);
        this.$store.commit('updateState', {
          path: `activeTemplate.data.sections[${sectionIndex}].isGenerating`,
          value: true,
        });

        // eslint-disable-next-line
        return this.$store.dispatch('getOpenAI', {
          searchString: this.$store.state.activeTemplate.data.openAIPrompt,
          sectionId: sectionToGenerate,
        }).then((suggestionsForSection) => {
          // update section
          this.saveSelectedSuggestedResources({
            suggestionsForSection,
            sectionId: sectionToGenerate,
          });

          this.$store.commit('updateState', {
            path: `activeTemplate.data.sections[${sectionIndex}].isGenerating`,
            value: false,
          });

          // eslint-disable-next-line
          this.initializingStatus(module.id, true);
        });
      });

      this.modulesToGenerate.push({
        icon: 'none',
        id: 'ui_preview',
        isInitialized: 'progress',
      });

      await Promise.all(promises);
      await this.$store.dispatch('previewModel');

      // handle other sections
      // initialize financing with autoloan
      const additionalModulesToInitialize = [];
      if (modules.some((module) => module.id === 'module_financing')) {
        this.saveSelectedSuggestedResources({
          suggestionsForSection: [{
            name: this.translate('ui_section_financing__loan'),
            rel: 'loan',
            formula: {
              id: 'autodrawdownloan',
              name: 'Revolving Credit Drawdown',
            },
          }],
          sectionId: 'section_financing',
        });
        additionalModulesToInitialize.push('module_financing');
      }

      // add all the rest
      additionalModulesToInitialize.push(...modules.reduce((arr, module) => {
        if (module.isInitialized !== true) {
          arr.push(module.id);
        }
        return arr;
      }, []));

      this.initializingStatus(additionalModulesToInitialize, true);

      this.$store.dispatch('updateState', {
        path: 'activeTemplate.name',
        value: `${this.$store.state.activeTemplate.data.openAIPrompt}`,
      });

      this.$store.dispatch('updateState', {
        path: 'activeTemplate.isGenerating',
        value: 'done',
      });

      // show onboarding dialog
      this.$store.commit('updateState', {
        path: 'activeTemplate.showOnboardingDialog',
        value: true,
      });

      // enable editing
      this.$store.commit('updateState', {
        path: 'isEditingToolsVisible',
        value: true,
      });

      // trigger template save once
      this.$store.dispatch('debouncedSaveRemoteTemplate', {
        template: this.$store.state.activeTemplate,
        skipPreviewUpdate: true,
      });
    },
    selectTemplateScenario(templateScenario) {
      if (!templateScenario.default) {
        // eslint-disable-next-line
        templateScenario.selected = !templateScenario.selected;
      }
      // check all scenario modules
      templateScenario.modules.forEach((moduleId) => {
        const module = this.$store.state.activeTemplate.data.modules.find((m) => m.id === moduleId);
        // eslint-disable-next-line
        module.isEnabled = templateScenario.selected;
      });
    },
  },
  mounted() {
    const businessCategoryInputEl = this.$refs.businessCategory && this.$refs.businessCategory.$el.querySelector('input');
    if (businessCategoryInputEl) {
      businessCategoryInputEl.select();
    }
    // templateScenarios
    this.templateScenarios = [{
      content: this.translate('ui_dialog_onboarding__scenario1__title'),
      description: this.translate('ui_dialog_onboarding__scenario1__description'),
      modules: ['module_cover', 'module_content', 'module_assumptions', 'module_revenue', 'module_cos', 'module_sga', 'module_wc', 'module_fixedassets', 'module_financing', 'module_is', 'module_bs', 'module_cf'],
      // sections: ['section_sales', 'section_sga', 'section_cos', 'section_wc', 'section_fixedassets', 'section_financing'],
      selected: true,
      default: true,
    }, {
      content: this.translate('ui_dialog_onboarding__scenario2__title'),
      description: this.translate('module_highlights_ip'),
      modules: ['module_ip'],
      sections: ['section_npv'],
      selected: false,
    }, {
      content: this.translate('module_ratios_name__long'),
      description: this.translate('module_highlights_ratios'),
      modules: ['module_ratios'],
      selected: false,
    }, {
      content: this.translate('module_charts_name__long'),
      description: `${this.translate('module_highlights_charts')} (available only in Google Sheets)`,
      modules: ['module_charts', 'module_chartsdata'],
      selected: false,
    }, {
    //   content: this.translate('Dashboard'),
    //   description: this.translate('Enhance blah ui_dialog_onboarding__scenario2__description'),
    //   modules: [],
    //   selected: false,
    // }, {
      content: this.translate('ui_dialog_onboarding__fill_random'),
      description: null, // this.translate('Enhance blah ui_dialog_onboarding__scenario2__description'),
      modules: [],
      sections: [],
      selected: false,
      id: 'random-data',
    }];
  },
  computed: {
    itemsToGenerate() {
      const result = this.modulesToGenerate.reduce((arr, m) => {
        if (m.isInitialized === 'progress') {
          arr.push({
            icon: m.icon,
            label: m.id ? this.translate(m.nameLong || m.id) : m.label,
          });
        }
        return arr;
      }, []);
      return result;
    },
    periods() {
      return [{
        text: this.translate('month'),
        value: 'month',
      }, {
        text: this.translate('quarter'),
        value: 'quarter',
      }, {
        text: this.translate('year'),
        value: 'year',
      }];
    },
    section() {
      return this.$store.state.activeTemplate.data.sections.find((section) => section.id === 'section_environment');
    },
    currencyMultiplier: {
      get() {
        return !this.section.isInitialized ? 'none' : false;
      },
      set(radioValue) {
        const { language } = this.$store.state.activeTemplate;
        const isMultiplierPrefixed = language === 'ru';
        const currencyName = this.$store.state.activeTemplate.data.coreResources[0].name;
        const translatedRadioValue = radioValue !== 'none' ? this.translate(radioValue) : '';
        let result;
        if (isMultiplierPrefixed) {
          result = `${translatedRadioValue}${currencyName}`;
        } else {
          result = translatedRadioValue ? `${currencyName} ${this.translate(translatedRadioValue)}` : currencyName;
        }
        this.$refs.defaultCurrency.$refs.input.value = result;
      },
    },
    defaultCurrency() {
      return this.$store.state.activeTemplate.data.coreResources[0].name;
    },
    incomeTaxRate: {
      get() {
        // eslint-disable-next-line
        return this.$store.state.activeTemplate ? this.$store.state.activeTemplate.data.env.sectionResources[0].flows[0].fcst[0].scenarios[0].data : null;
      },
      set(value) {
        this.$store.dispatch('updateState', {
          path: 'activeTemplate.data.coreResources[1].value',
          value,
        });
      },
    },
  },
};
</script>
